module.exports = __webpack_public_path__ + "static/media/06.8db2f74f.png";